import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { useViewNDVIContext } from "./ViewNDVIContext";
import { useErrorHandler } from "../../../../../../_metronic/helpers/ErrorHandler";
import { openAlert } from "../../../../../../_metronic/elements/NotificationAlert";
import ReportDeleteConfirmation from "../../ReportDeleteConfirmation";
import * as ReportService from "../../services/ReportService";
import { useNDVIReportContext } from "../NDVIReportContext";

const DeleteReport = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { errorHandler } = useErrorHandler();
  const { deleteReport, setDeleteReport } = useViewNDVIContext();
  const [deleting, setDeleting] = useState(false);
  const { id } = useParams();
  const { load } = useNDVIReportContext();

  const handleDelete = () => {
    setDeleting(true);
    errorHandler(ReportService.deleteNdviReport(id)).then((res) => {
      if (res.ok) {
        openAlert(
          "success",
          t("reports:ndvi.delete.success.title"),
          t("reports:ndvi.delete.success.message")
        );
        load();
        navigate("/gis/reports/ndvi");
      }

      setDeleting(false);
    });
  };

  if (deleteReport === false) {
    return <></>;
  }

  return (
    <ReportDeleteConfirmation
      title={t("reports:ndvi.delete.question")}
      confirmLabel={t("reports:ndvi.delete.yes_button")}
      cancelLabel={t("reports:ndvi.delete.no_button")}
      deleting={deleting}
      onConfirm={handleDelete}
      onCancel={() => setDeleteReport(false)}
    />
  );
};

export default DeleteReport;
